<template>
  <div class="home">
    <nav>中知在线顾问后台</nav>
    <div class="above">
      <div class="logo">
        <img src="@/assets/images/firstlogo.png" alt />
      </div>
      <div class="close" @click="exit">
        <i>
          <img src="@/assets/images/close.png" alt srcset />
        </i>
        <span>退出账号</span>
      </div>
    </div>
    <div class="header">
      <div class="information">
        <p>账号：{{personalData.username}}</p>
        <p class="name">姓名：{{personalData.name}}</p>
        <p>区域：{{personalData.region}}</p>
      </div>
      <div class="btn">
        <van-button round type="info" plain color="#fff" class="personal" @click="$router.push('/personaldata')">个人资料
        </van-button>
        <van-button round type="info" plain color="#fff" @click="$router.push('/changepassword')">修改密码</van-button>
      </div>
    </div>
    <div class="center">
      <div v-for="(item,index) in list" :key="index" @click="$router.push(item.lianjie)">
        <i class="yuan">
          <img :src="item.photo" alt :class="item.cla" />
        </i>
        <p>{{item.title}}</p>
        <i class="remind" v-if="financeneed" v-show="index===0 && new_order!==''&&new_order!=='0'">
          <span>{{financeneed}}</span>
        </i>
        <i class="remind" v-if="new_order" v-show="index===1 && new_order!==''&&new_order!=='0'">
          <span>{{new_order}}</span>
        </i>
        <i class="remind" v-if="new_level" v-show="index===2 && new_level!==''&&new_level!=='0'">
          <span>{{new_level}}</span>
        </i>
        <i class="remind" v-if="new_user" v-show="index===3 && new_user!==''&&new_user!=='0'">
          <span>{{new_user}}</span>
        </i>
      </div>
    </div>
  </div>
</template>

<script>
import { adminInfo, loginOut, untreatedNums } from '@/api/user.js'
export default {
  name: 'home',
  props: {},
  data () {
    return {
      list: [
        {
          photo: require('@/assets/images/financing.png'),
          lianjie: '/financing',
          title: '融资项目申请',
          cla: 'ica1'
        },
        {
          photo: require('@/assets/images/ordermanagement.png'),
          lianjie: '/ordermanagement',
          title: '订单管理',
          cla: 'ica2'
        },
        {
          photo: require('@/assets/images/Membermanagement.png'),
          lianjie: '/membermanagement',
          title: '会员管理',
          cla: 'ica3'
        },
        {
          photo: require('@/assets/images/Newmembers.png'),
          lianjie: '/newmembers',
          title: '新增会员',
          cla: 'ica4'
        },
        {
          photo: require('@/assets/images/Evaluationmanagement.png'),
          lianjie: '/evaluationmanagement',
          title: '评估项目管理',
          cla: 'ica5'
        }
      ],
      personalData: {},
      financeneed: '',
      new_order: '',
      new_user: '',
      new_level: ''
    }
  },
  computed: {},
  created () { },
  mounted () {
    if (!(Object.keys(this.$store.state.userInfo).length)) {
      this.getpersonaldata()
    } else {
      this.personalData = this.$store.state.userInfo
    }
    this.untreatedNums()
  },
  watch: {},
  methods: {
    async getpersonaldata () {
      try {
        const { data } = await adminInfo()
        this.personalData = data
        this.$store.commit('setUserInfo', data)
      } catch (error) {
        return error.message
      }
    },
    async untreatedNums () {
      try {
        const { data } = await untreatedNums()
        this.financeneed = data.financeneed
        this.new_level = data.new_level
        this.new_order = data.new_order
        this.new_user = data.new_user
      } catch (error) {
        return error.message
      }
    },
    async LogOut () {
      try {
        const data = await loginOut()
        if (data.error_code === 1) {
          window.localStorage.removeItem('token')
          window.sessionStorage.removeItem('userInfo')
          this.$store.commit('setUser', '')
          this.$store.commit('setUserInfo', '')
          this.$toast(data.msg)
          setTimeout(() => {
            this.$router.push('/login')
          }, 2000)
        } else {
          this.$toast(data.msg)
        }
      } catch (error) {
        return error.message
      }
    },
    exit () {
      this.$dialog
        .confirm({
          title: '确认要退出吗?',
          confirmButtonColor: '#2DADB1'
        })
        .then(() => {
          this.LogOut()
        })
        .catch(() => {
          this.$dialog.close()
        })
    }
  },
  components: {}
}
</script>

<style scoped lang="less">
.home {
  font-family: "MicrosoftYaHei";
  background: url("../../assets/images/home.png");
  width: 100%;
  height: 120%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  // background-color: #fff;
  background-attachment: fixed;
  z-index: -10;
  .above {
    display: flex;
    justify-content: space-between;
    margin: 14px 43px 0 50px;
    height: 72px;
    line-height: 72px;
    .logo {
      width: 212px;
      height: 72px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .close {
      // padding-top: -5px;
      height: 80px;
      i {
        display: inline-block;
        width: 32px;
        height: 34px;
      }
      img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
      }
      span {
        font-size: 28px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        padding-left: 15px;
        vertical-align: middle;
      }
    }
  }
  nav {
    background-color: #fff;
    width: 100%;
    height: 88px;
    text-align: center;
    line-height: 88px;
    font-size: 30px;
    color: #151515;
  }
  .header {
    display: flex;
    font-size: 30px;
    color: #fff;
    padding-top: 39px;
    padding-left: 30px;
    padding-right: 25px;
    justify-content: space-around;
    .name {
      padding: 20px 0;
    }
    .information {
      width: 300px;
    }
    .btn {
      padding-top: 105px;
      .personal {
        margin-right: 34px;
      }
    }
  }
  /deep/ .van-button--plain {
    background-color: transparent;
  }
  /deep/ .van-button {
    width: auto;
    height: 60px;
    line-height: 0px;
    font-size: 28px;
  }
  /deep/ .van-button--normal {
    padding: 0;
    padding: 15px;
  }
  .center {
    margin-top: 70px;
    div {
      width: 680px;
      height: 139px;
      background-color: #fff;
      margin: 0 auto;
      text-align: center;
      line-height: 139px;
      border-radius: 70px;
      position: relative;
      margin-bottom: 30px;
      font-size: 40px;
      &:first-child {
        .remind {
          left: 520px;
        }
      }
      .remind {
        display: inline-block;
        min-width: 40px;
        height: 40px;
        width: auto;
        background-color: #e83c34;
        border-radius: 20px;
        position: absolute;
        left: 480px;
        top: 22px;
        font-size: 26px;
        color: #fff;
        font-family: "Microsoft Yahei", sans-serif;
        span {
          display: block;
          height: 40px;
          line-height: 26px;
          text-align: center;
          padding: 8px;
          box-sizing: border-box;
        }
      }
    }
    .yuan {
      display: inline-block;
      width: 215px;
      height: 139px;
      background-color: #2dadb1;
      position: absolute;
      left: 0;
      top: 0;
      overflow: hidden;
      border-radius: 70px;
      line-height: 139px;
      .ica1 {
        width: 89px;
        height: 70px;
        vertical-align: middle;
      }
      .ica2 {
        width: 77px;
        height: 81px;
        vertical-align: middle;
      }
      .ica3 {
        width: 95px;
        height: 84px;
        vertical-align: middle;
      }
      .ica4 {
        width: 76px;
        height: 75px;
        vertical-align: middle;
      }
      .ica5 {
        width: 78px;
        height: 70px;
        vertical-align: middle;
      }
    }
    p {
      margin-left: 100px;
      text-align: center;
    }
  }
  /deep/ .van-button--default {
    background-color: #2dadb1;
  }
}
</style>
